import { Http, RequestOptions, RequestOptionsArgs, Response, XHRBackend } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { RefreshTokenService } from '../authentication/refresh-token.service';
import { deleteSession, getSession } from '../storage.service';
import { AuthOptions } from './auth.options';
import { PendingService } from './pending.service';

const hasHeader = (header: string, options: RequestOptionsArgs) => (
  options
  && options.headers
  && options.headers.has(header)
);

export class HttpService extends Http {
  constructor(
    backend: XHRBackend,
    defaultOptions: AuthOptions,
    private router: Router,
    private refreshTokenService: RefreshTokenService,
    private pendingService: PendingService
  ) {
    super(backend, defaultOptions);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.getControlledRefresh().switchMap(
      () => {
        this.onStart(options);
        return super.get(url, this.requestOptions(options))
          .first()
          .catch(this.onCatch)
          .finally(this.onFinally(options));
      }
    );
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.getControlledRefresh().switchMap(
      () => {
        this.onBlockingStart(options);
        return super.post(url, body, this.requestOptions(options))
          .first()
          .catch(this.onCatch)
          .finally(this.onBlockingFinally(options));
      }
    );
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.getControlledRefresh().switchMap(
      () => {
        this.onBlockingStart(options);
        return super.put(url, body, this.requestOptions(options))
          .first()
          .catch(this.onCatch)
          .finally(this.onBlockingFinally(options));
      }
    );
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.getControlledRefresh().switchMap(
      () => {
        this.onBlockingStart(options);
        return super.delete(url, this.requestOptions(options))
          .first()
          .catch(this.onCatch)
          .finally(this.onBlockingFinally(options));
      }
    );
  }

  private requestOptions = (options?: RequestOptionsArgs): RequestOptionsArgs => {
    const authOptions = new AuthOptions(options || new RequestOptions());
    authOptions.setAuthentication(getSession());

    return authOptions;
  }

  private onCatch = (error: any, caught: Observable<any>): Observable<any> => {
    if (error && error.status === 401) {
      deleteSession();
      this.router.navigate(['/login']);
      return caught;
    }

    return Observable.throw(error);
  }

  private getControlledRefresh = () => {
    this.refreshTokenService.checkRefreshToken();
    return this.refreshTokenService.isRefreshing
      .filter((refreshing: boolean) => !refreshing)
      .first();
  }

  private onBlockingStart = (options: RequestOptionsArgs) => {
    if (hasHeader('no-blocking', options)) {
      this.pendingService.addPending();
    } else {
      this.pendingService.showBlockingPending();
    }
  }

  private onStart = (options: RequestOptionsArgs) => {
    if (hasHeader('blocking', options)) {
      this.pendingService.showBlockingPending();
    } else {
      this.pendingService.addPending();
    }
  }

  private onBlockingFinally = (options: RequestOptionsArgs) => () => {
    if (hasHeader('no-blocking', options)) {
      this.pendingService.removePending();
    } else {
      this.pendingService.hideBlockingPending();
    }
  }

  private onFinally = (options: RequestOptionsArgs) => () => {
    if (hasHeader('blocking', options)) {
      this.pendingService.hideBlockingPending();
    } else {
      this.pendingService.removePending();
    }
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/base/http.service.ts